var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.attribute)?_c('span',[_vm._l((_vm.attrIcons),function(attrIcon){return [(_vm.match(attrIcon))?_c('el-tooltip',{key:attrIcon.icon,attrs:{"content":_vm.description(attrIcon),"placement":"top","effect":"light"}},[_c('d2-icon',{staticClass:"attr-icon",class:attrIcon.class,style:({
                 color: attrIcon.color
               }),attrs:{"name":attrIcon.icon}})],1):_vm._e()]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }